module.exports = __webpack_public_path__ + "b593595f19b56ef8d5f9d85ff180cd57.svg";